import CustomBottom from "../../components/CustomBottom";
import CustomHeader from "../../components/CustomHeader";
import React from "react";

export default function Museum() {
  const file = [
    { link: "/img/Museum (1).png" },
    { link: "/img/Museum (2).png" },
    { link: "/img/Museum (3).png" },
    { link: "/img/Museum (4).png" },
    { link: "/img/Museum (5).png" },
    { link: "/img/Museum (6).png" },
  ];
  const fileDownload = [
    {
      name: "พิพิธภัณฑ์ผ้าอีสาน2568",
      link: "/pdf/พิพิธภัณฑ์ผ้าอีสาน2568-Watermark.pdf",
    },
    {
      name: "หนังสือภูมิปัญญาผ้าขิด",
      link: "/pdf/หนังสือภูมิปัญญาผ้าขิด-Watermark.pdf",
    },
    {
      name: "Textile Museum",
      link: "/pdf/Isan_textile museum-watermark.pdf",
    },
  ];
  return (
    <div className="fade_In">
      <CustomHeader />

      <div
        className="flex flex-row items-center gap-4  pt-[180px]"
        style={{ justifyContent: "center" }}
      >
        <div className="w-5 h-5 bg-[#B36427]" />
        <div className=" font-semibold text-[28px] sm:text-[36px]">
          ISAN Museum Of Textiles
        </div>
        <div className="w-5 h-5 bg-[#B36427]" />
      </div>
      <div className="text-center mt-10 px-5">
        <p className="text-4xl">"พิพิธภัณฑ์ผ้าอีสาน"</p>
        <br />
        <p>
          จัดสร้างขึ้นเพื่อให้เป็นแหล่งเรียนรู้รวบรวมองค์ความรู้ภูมิปัญญาผ้าทออีสาน
          รวมทั้งลวดลายผ้าทอโบราณ โดยจัดแสดงเรื่องราวภูมิปัญญาในวิถีวัฒนธรรม
          "การต่ำหูก"
          ซึ่งเป็นมรดกที่สั่งสมสืบต่อกันมาหลายชั่วอายุของแม่หญิงอีสาน
          ทั้งนี้เพื่อเป็นคนรุ่นหลังได้เห็นได้รู้ถึงรากเหง้าบรรพชนคนอีสาน
          โดยเฉพาะหัตถกรรม "ต่ำหูก" ที่มีความสวยงามและลวดลายที่แฝงไว้ด้วยคติ
          ฮีตคอง ประเพณีอันดีงาม
        </p>
      </div>
      <div className="md:flex flex-row flex-wrap hidden justify-center items-center gap-2 my-5">
        <iframe
          width="650"
          height="365.625"
          src="https://www.youtube.com/embed/D-Ebip6f8Eg?si=-Qqo03XpchB5uszh"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="rounded-2xl"
        />
        <iframe
          width="650"
          height="365.625"
          src="https://www.youtube.com/embed/_yp7JsncOjs?si=2GUJeVml5yFz2n6g"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="rounded-2xl"
        />
      </div>
      <div className="flex flex-col md:hidden justify-center items-center gap-2 my-5">
        <iframe
          width="325"
          height="182.8125"
          src="https://www.youtube.com/embed/D-Ebip6f8Eg?si=-Qqo03XpchB5uszh"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="rounded-2xl"
        />
        <iframe
          width="325"
          height="182.8125"
          src="https://www.youtube.com/embed/_yp7JsncOjs?si=2GUJeVml5yFz2n6g"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="rounded-2xl"
        />
      </div>
      <div className="flex flex-col w-[230px] items-start gap-2 justify-center mx-auto">
        {fileDownload.map((item, i) => {
          return (
            <a
              key={i}
              href={item.link}
              target="_blank"
              className="flex flex-row items-center gap-5 text-[#B36427]  font-bold"
            >
              <img
                src="/img/icon_news.png"
                className="w-[40px] object-contain"
              />
              <p>{item.name}</p>
            </a>
          );
        })}
      </div>
      <div className="px-[20vw] py-[24px] flex flex-col gap-5">
        {file.map((item, i) => {
          return (
            <img key={i} src={item.link} className="w-full object-contain" />
          );
        })}
      </div>
      <CustomBottom />
    </div>
  );
}
